export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics = [
  {
    id: 1,
    title: '重生之都市仙尊',
    author: '林风',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20man%20in%20modern%20city%20with%20magical%20energy%20surrounding%20him%2C%20dramatic%20lighting%2C%20clean%20simple%20background%20with%20warm%20tones%2C%20digital%20art%20style%2C%20vertical%20portrait%20composition%2C%20soft%20shadows%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一代仙尊重生回到都市少年时代，带着前世记忆重新开始，纵横都市、修炼升级，逆天改命的故事。',
    rating: 9.5,
    views: 1280000,
    updateDate: '2026-08-05',
    chapters: 186,
    status: '连载中',
    tags: ['重生', '修仙', '都市'],
    chapters_list: [
      { num: 186, title: '第186话 终局之战（三）', date: '2026-08-05' },
      { num: 185, title: '第185话 终局之战（二）', date: '2026-08-04' },
      { num: 184, title: '第184话 终局之战（一）', date: '2026-08-03' },
      { num: 183, title: '第183话 暗流涌动', date: '2026-08-02' },
      { num: 182, title: '第182话 新的盟友', date: '2026-08-01' },
      { num: 181, title: '第181话 突破极限', date: '2026-07-31' },
      { num: 180, title: '第180话 决战前夕', date: '2026-07-30' },
    ],
  },
  {
    id: 2,
    title: '秘密恋爱手册',
    author: '韩小朵',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20beautiful%20young%20couple%20sharing%20earbuds%20under%20cherry%20blossoms%2C%20soft%20pink%20atmosphere%2C%20clean%20simple%20background%2C%20warm%20gentle%20lighting%2C%20romantic%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '高冷校草和迷糊少女的秘密恋爱，从互相讨厌到渐渐心生情愫，一段甜蜜又波折的校园爱情故事。',
    rating: 9.2,
    views: 960000,
    updateDate: '2026-08-04',
    chapters: 142,
    status: '连载中',
    tags: ['校园', '恋爱', '甜蜜'],
    chapters_list: [
      { num: 142, title: '第142话 告白', date: '2026-08-04' },
      { num: 141, title: '第141话 心动的瞬间', date: '2026-08-03' },
      { num: 140, title: '第140话 雨中的约定', date: '2026-08-02' },
      { num: 139, title: '第139话 误会解除', date: '2026-08-01' },
      { num: 138, title: '第138话 他的温柔', date: '2026-07-31' },
    ],
  },
  {
    id: 3,
    title: '暗夜猎手',
    author: '金泰浩',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20powerful%20hunter%20with%20dark%20outfit%20holding%20a%20weapon%20in%20dystopian%20cityscape%2C%20dramatic%20contrast%20lighting%2C%20clean%20simple%20background%2C%20intense%20mood%2C%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '在怪物横行的末世世界，猎人们觉醒异能守护人类最后的希望。主角从底层崛起，成为最强猎人的传奇故事。',
    rating: 9.4,
    views: 2150000,
    updateDate: '2026-08-05',
    chapters: 210,
    status: '连载中',
    tags: ['异能', '末世', '热血'],
    chapters_list: [
      { num: 210, title: '第210话 觉醒时刻', date: '2026-08-05' },
      { num: 209, title: '第209话 极限突破', date: '2026-08-03' },
      { num: 208, title: '第208话 S级降临', date: '2026-08-01' },
      { num: 207, title: '第207话 猎人之夜', date: '2026-07-30' },
    ],
  },
  {
    id: 4,
    title: '魔王大人想退休',
    author: '星野',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20demon%20lord%20disguised%20as%20a%20normal%20office%20worker%20in%20modern%20setting%2C%20humorous%20expression%2C%20warm%20lighting%2C%20clean%20simple%20background%2C%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '统治魔界三千年的魔王大人厌倦了打打杀杀，偷偷跑到人界想过平凡生活，却总被各种麻烦找上门。',
    rating: 9.3,
    views: 890000,
    updateDate: '2026-08-03',
    chapters: 98,
    status: '连载中',
    tags: ['搞笑', '奇幻', '日常'],
    chapters_list: [
      { num: 98, title: '第98话 身份暴露？', date: '2026-08-03' },
      { num: 97, title: '第97话 新邻居', date: '2026-08-01' },
      { num: 96, title: '第96话 公司团建', date: '2026-07-30' },
      { num: 95, title: '第95话 魔界来信', date: '2026-07-28' },
    ],
  },
  {
    id: 5,
    title: '你的名字在我心里',
    author: '柳智恩',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20a%20thoughtful%20woman%20looking%20out%20a%20rainy%20window%2C%20melancholic%20atmosphere%2C%20soft%20blueish%20gray%20tones%2C%20clean%20simple%20background%2C%20emotional%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '失去记忆的少女在陌生城市追寻过去，遇见了似乎认识她的神秘男子。一段关于记忆与救赎的感人故事。',
    rating: 9.6,
    views: 760000,
    updateDate: '2026-08-04',
    chapters: 76,
    status: '连载中',
    tags: ['治愈', '悬疑', '爱情'],
    chapters_list: [
      { num: 76, title: '第76话 真相大白', date: '2026-08-04' },
      { num: 75, title: '第75话 最后的碎片', date: '2026-08-02' },
      { num: 74, title: '第74话 他记得一切', date: '2026-07-31' },
      { num: 73, title: '第73话 旧照片', date: '2026-07-29' },
    ],
  },
  {
    id: 6,
    title: '九尾狐传',
    author: '朴志浩',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20thriller%20illustration%20of%20a%20mysterious%20nine-tailed%20fox%20spirit%20in%20modern%20Seoul%20night%2C%20eerie%20atmosphere%2C%20clean%20simple%20background%2C%20dark%20mood%20with%20warm%20accents%2C%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '现代首尔隐藏着千年九尾狐，她以人类形态生活在都市中。当连环杀人案牵扯出古老的秘密，她不得不现身。',
    rating: 9.1,
    views: 1340000,
    updateDate: '2026-08-02',
    chapters: 165,
    status: '连载中',
    tags: ['妖怪', '悬疑', '都市'],
    chapters_list: [
      { num: 165, title: '第165话 狐火', date: '2026-08-02' },
      { num: 164, title: '第164话 追踪者', date: '2026-07-31' },
      { num: 163, title: '第163话 古老的契约', date: '2026-07-29' },
    ],
  },
  {
    id: 7,
    title: '社畜的逆袭',
    author: '姜明秀',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20a%20funny%20office%20worker%20with%20exaggerated%20expression%20in%20chaotic%20office%2C%20bright%20colorful%20style%2C%20clean%20simple%20background%2C%20humorous%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '普通社畜意外获得时间回溯能力，每次搞砸都能重来，在职场掀起一场啼笑皆非的逆袭之路。',
    rating: 9.0,
    views: 670000,
    updateDate: '2026-08-01',
    chapters: 88,
    status: '连载中',
    tags: ['职场', '搞笑', '异能'],
    chapters_list: [
      { num: 88, title: '第88话 升职日', date: '2026-08-01' },
      { num: 87, title: '第87话 完美的方案', date: '2026-07-30' },
      { num: 86, title: '第86话 重启第50次', date: '2026-07-28' },
    ],
  },
  {
    id: 8,
    title: '深夜食堂：魔女篇',
    author: '尹素熙',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20illustration%20of%20a%20mysterious%20witch%20chef%20in%20a%20dimly%20lit%20restaurant%20at%20night%2C%20eerie%20warm%20glow%2C%20clean%20simple%20background%2C%20dark%20atmospheric%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '只在午夜开门的食堂，魔女老板为特殊客人烹饪诡异的料理。每个客人背后都有一个令人毛骨悚然的故事。',
    rating: 8.9,
    views: 540000,
    updateDate: '2026-08-03',
    chapters: 54,
    status: '连载中',
    tags: ['惊悚', '奇幻', '美食'],
    chapters_list: [
      { num: 54, title: '第54话 最后的客人', date: '2026-08-03' },
      { num: 53, title: '第53话 人鱼的眼泪', date: '2026-07-31' },
      { num: 52, title: '第52话 不死的食谱', date: '2026-07-28' },
    ],
  },
  {
    id: 9,
    title: '猫咪咖啡馆',
    author: '李夏恩',
    category: 'daily',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20a%20gentle%20barista%20and%20adorable%20cats%2C%20warm%20sunlight%2C%20clean%20simple%20background%2C%20heartwarming%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '辞去工作后开了一家猫咪咖啡馆的少女，与各式各样的猫咪和客人们发生的温暖日常故事。',
    rating: 9.3,
    views: 480000,
    updateDate: '2026-08-04',
    chapters: 62,
    status: '连载中',
    tags: ['治愈', '日常', '猫咪'],
    chapters_list: [
      { num: 62, title: '第62话 新来的小橘', date: '2026-08-04' },
      { num: 61, title: '第61话 雨天的客人', date: '2026-08-02' },
      { num: 60, title: '第60话 领养日', date: '2026-07-31' },
    ],
  },
  {
    id: 10,
    title: '剑与魔法学院',
    author: '崔宇镇',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20students%20in%20a%20magical%20academy%20with%20swords%20and%20spells%2C%20grand%20castle%20background%2C%20warm%20epic%20lighting%2C%20clean%20simple%20composition%2C%20digital%20art%20style%2C%20vertical%20portrait&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '平凡少年意外被选入皇家剑与魔法学院，在这里他发现了自己隐藏的天赋，踏上成为传奇魔法剑士的道路。',
    rating: 9.2,
    views: 1780000,
    updateDate: '2026-08-05',
    chapters: 195,
    status: '连载中',
    tags: ['学院', '魔法', '热血'],
    chapters_list: [
      { num: 195, title: '第195话 毕业试炼', date: '2026-08-05' },
      { num: 194, title: '第194话 最终考核', date: '2026-08-03' },
      { num: 193, title: '第193话 团队之战', date: '2026-08-01' },
    ],
  },
  {
    id: 11,
    title: '我的ID是江南美人',
    author: '朴恩熙',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20beauty%20romance%20illustration%20of%20a%20confident%20woman%20in%20modern%20Seoul%20street%2C%20fashionable%20style%2C%20warm%20sunset%20lighting%2C%20clean%20simple%20background%2C%20chic%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '从小因外貌自卑的少女通过整容获得新生，进入大学后展开全新人生，却意外遇到了知道她过去的人。',
    rating: 9.4,
    views: 3200000,
    updateDate: '2026-08-05',
    chapters: 230,
    status: '已完结',
    tags: ['校园', '恋爱', '成长'],
    chapters_list: [
      { num: 230, title: '第230话 真正的美丽（完）', date: '2026-08-05' },
      { num: 229, title: '第229话 幸福的定义', date: '2026-08-03' },
      { num: 228, title: '第228话 毕业典礼', date: '2026-08-01' },
    ],
  },
  {
    id: 12,
    title: '地下城的独行者',
    author: '韩智勋',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dungeon%20action%20illustration%20of%20a%20lone%20warrior%20in%20dark%20dungeon%20with%20glowing%20sword%2C%20dramatic%20light%20rays%2C%20clean%20simple%20background%2C%20epic%20digital%20art%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '全球出现神秘地下城，只有觉醒了能力的猎人们才能攻略。一个从不组队的独行侠，在地下城中创造了无数传奇。',
    rating: 9.7,
    views: 4500000,
    updateDate: '2026-08-05',
    chapters: 258,
    status: '连载中',
    tags: ['地下城', '战斗', '系统'],
    chapters_list: [
      { num: 258, title: '第258话 终极楼层', date: '2026-08-05' },
      { num: 257, title: '第257话 BOSS战', date: '2026-08-04' },
      { num: 256, title: '第256话 99层突破', date: '2026-08-03' },
    ],
  },
];

export const hotComics = [1, 3, 12, 5, 2, 11];

export const latestUpdates = [12, 1, 3, 11, 5, 2, 9, 10];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20illustration%20style%20young%20man%20avatar%20portrait%2C%20simple%20warm%20background%2C%20friendly%20expression%2C%20digital%20art&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '基德漫画网是我用过最好的韩漫平台！更新速度超快，画质清晰，阅读体验一流。无删减版本真的太良心了。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 2,
    name: '韩漫爱好者小美',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20illustration%20style%20young%20woman%20avatar%20portrait%2C%20simple%20warm%20background%2C%20smiling%20expression%2C%20digital%20art&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '这里的漫画种类太全了！恋爱、奇幻、动作各种类型都有，每天都有新漫画更新，根本停不下来。',
    rating: 5,
    date: '2026-07-18',
  },
  {
    id: 3,
    name: '资深漫友阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20illustration%20style%20man%20avatar%20portrait%20with%20glasses%2C%20simple%20warm%20background%2C%20calm%20expression%2C%20digital%20art&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '追了三年韩漫，基德漫画网是我最信赖的平台。下拉式阅读非常顺滑，而且没有烦人的广告弹窗。',
    rating: 5,
    date: '2026-07-15',
  },
];